module.exports = "/_next/static/images/ball-62788b636060f715212f9e20a8a21b8a.png";